export const visitorsCardStyles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: "24px",
  },
  middle: {
    marginBottom: "24px",
  },
  middleTitle: {
    fontWeight: 500,
    fontSize: "42px",
    lineHeight: "61px",
    color: "#103B66",
  },
  bottom: {
    display: "flex",
    justifyContent: "space-between",
    color: "#21B8F9",
  },
  bottomText: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  // month: {
  //   display: "flex",
  //   justifyContent: "center",
  // },
  // monthText: {
  //   fontWeight: 400,
  //   fontSize: "14px",
  //   lineHeight: "18px",
  //   color: "#666666",
  // },
  // expand: {
  //   marginLeft: "8px",
  // },
};
